module.exports = __webpack_public_path__ + "header-profile-skin-2.8307c45ca34d4af71912.png";


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/assets/styles/patterns/header-profile-skin-2.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-2.png
// module chunks = 1